import { API_URL } from "../../shared/constants";
import { emptySplitApi } from "../emptySplit-api";

export interface AuditTrailUser {
  _id: string | null;
  name: string | null;
  username: string | null;
}

export interface AuditTrailEntry {
  itemCode?: string | null;
  action?: string | null;
  fieldName: string;
  previousValue: string | null;
  newValue: string | null;
  updatedBy: AuditTrailUser | null;
  updatedAt: string | null;
}

export interface AuditTrailListResponse {
  status: boolean;
  count: number;
  list: AuditTrailEntry[];
}

export interface AuditTrailListQuery {
  orderId: string;
  limit: number;
  skip: number;
  sort: string;
  sortBy: string;
}

export const auditApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    auditTrailList: builder.query<AuditTrailListResponse, AuditTrailListQuery>({
      query: (data) => ({
        url: `/${API_URL.ORDERS}/${API_URL.AUDIT_TRAIL}/${data.orderId}`,
        method: "post",
        body: {
          limit: data.limit,
          skip: data.skip,
          sort: data.sort,
          sortBy: data.sortBy,
        },
      }),
      providesTags: (result, error, data) => [
        { type: "AuditTrail" as const, id: data.orderId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useAuditTrailListQuery } = auditApi;
